<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dramatis Personae</span></p>
<p class="P_WFP_LineItem">Jean-Claude (Rod) Simone</p>
<p class="P_WFP_LineItem">Julie Phillips Simone—Rod’s wife</p>
<p class="P_WFP_LineItem">Nanette Marie Simone—Rod’s daughter</p>
<p class="P_WFP_LineItem">Major General Hank McCluney, US Army Air Corps—Rod’s (deceased) adoptive father</p>
<p class="P_WFP_LineItem">Mary McCluney—Rod’s adoptive mother</p>
<p class="P_WFP_SubChapHead"><span>Washington DC</span></p>
<p class="P_WFP_LineItem">Ambassador T. Edward Phillips—Rod’s father-in-law</p>
<p class="P_WFP_LineItem">Francine Phillips—Rod’s mother-in-law</p>
<p class="P_WFP_SubChapHead"><span>Colorado Springs</span></p>
<p class="P_WFP_LineItem">George Delante—Land developer and co-owner, High Country Construction</p>
<p class="P_WFP_LineItem">Elizabeth Delante—his wife</p>
<p class="P_WFP_LineItem">Fred Delante—his son</p>
<p class="P_WFP_LineItem">Jim-Tom Henderson—Co-owner, High Country Construction</p>
<p class="P_WFP_LineItem">Darius Moore—ex-El Paso County DA; Legal Counsel, Colorado Technical Associates</p>
<p class="P_WFP_SubChapHead"><span>United States Air Force Academy</span></p>
<p class="P_WFP_LineItem">Captain Bobby Andrew—Executive Officer, Department of Theoretical Mechanics</p>
<p class="P_WFP_LineItem">Brigadier General Stanley C. Beck<span style=" font-size: 0.75em; vertical-align: super;">†</span>—USAFA Commandant</p>
<p class="P_WFP_LineItem">Raf Garcia—waiter</p>
<p class="P_WFP_LineItem">Mrs. Gail McComas<span style=" font-size: 0.75em; vertical-align: super;">†</span>—Cadet hostess, 1955 to 1977</p>
<p class="P_WFP_LineItem">Ben Martin<span style=" font-size: 0.75em; vertical-align: super;">†</span>—USAFA football coach</p>
<p class="P_WFP_LineItem">Colonel Maas—Department Head and Permanent Professor, Department of Law</p>
<p class="P_WFP_LineItem">Brigadier General Robert F. McDermott<span style=" font-size: 0.75em; vertical-align: super;">†</span>—USAFA Dean of Faculty</p>
<p class="P_WFP_LineItem">Brigadier General Robert W. Strong, Jr.<span style=" font-size: 0.75em; vertical-align: super;">†</span>—USAFA Commandant</p>
<p class="P_WFP_LineItem">Colonel L. Bradford Whitney—Department Head and Permanent Professor, Department of Theoretical Mechanics</p>
<p class="P_WFP_SubChapHead"><span>Rod Simone’s USAFA classmates</span></p>
<p class="P_WFP_LineItem">Nino Baldacci<span style=" font-size: 0.75em; vertical-align: super;">†</span>—Cadet (Poughkeepsie, NY)</p>
<p class="P_WFP_LineItem">Sylvester “Sly” Winston Jakes—(Boston, MA)</p>
<p class="P_WFP_LineItem">Jeff Goldstein—(New York, NY)</p>
<p class="P_WFP_LineItem">Manuel Rojo—(Albuquerque, NM)</p>
<p class="P_WFP_LineItem">George Sanders—(Fort Worth, Texas)</p>
<p class="P_WFP_SubChapHead"><span>Other Locations</span></p>
<p class="P_WFP_LineItem">Captain Charlie “Rhino” Banner—Instructor pilot</p>
<p class="P_WFP_LineItem">“Beast”—Squadron Commander, 3525th Pilot Training Wing, Williams AFB</p>
<p class="P_WFP_LineItem">General “Speedy” Beaumont—Major General Hank McCluney’s WWII wingman</p>
<p class="P_WFP_LineItem">Captain “Jazz” Ferguson—Rod’s F-4 GIB (Guy-In-the-Backseat)</p>
<p class="P_WFP_LineItem">Major Tom Ranch—F-105 pilot, Rod Simone’s ex-ATO and ex-AOC</p>
<p class="P_WFP_LineItem">Professor Clifford Rhoades—Professor of Aeronautical Engineering, Stanford University</p>
<p class="P_WFP_LineItem">Barbara Richardson—Stanford graduate student, newscaster</p>
<p class="P_WFP_BodyTextFirstPara"><span style=" font-style: italic; font-size: 0.75em; vertical-align: super;">†—</span><i>Denotes an actual historical figure</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0007.vue?7af146b8